import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import QuestionnaireQuestionEntry from './questionnaireQuestionEntry';
import CustomButton from '../../customButton';
import {
  QUESTIONNAIRE_QUESTION_DEFAULT_OPTIONS_COUNT,
  QUESTIONNAIRE_QUESTION_MAX_OPTIONS,
  QUESTIONNAIRE_QUESTION_TYPES,
} from '../../../../constants/survey';
import { getItemById } from '../../../../utility/helpers';

const useStyles = makeStyles(({ spacing }) => ({
  addAnswerRow: {
    paddingLeft: spacing(9),
  },
  questionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing(9),
    gap: spacing(1.5),
    marginBottom: spacing(2),
  },
  questionIcon: {
    width: 16,
    height: 16,
    marginTop: spacing(-0.5),
  },
  questionIconMultiSelect: {
    width: 14,
    height: 14,
  },
}));

const Question = ({
  id,
  className = undefined,
  translations,
  errors = {},
  question,
  questionOptions,
  onDuplicate,
  onDelete,
  onSave,
  onPendingChange = undefined,
  onRegisterFlush = undefined,
  onAddAnswer,
  dragRef = undefined,
  dragProps = null,
}) => {
  const classes = useStyles();
  const isOpenEndedQuestion =
    question.type === QUESTIONNAIRE_QUESTION_TYPES.OPEN_TEXT;
  const optionsCount =
    question?.options?.length || QUESTIONNAIRE_QUESTION_DEFAULT_OPTIONS_COUNT;
  const { label, icon: QuestionIcon } = getItemById(
    questionOptions,
    question.type
  );

  const handleAddAnswer = () => {
    onAddAnswer(optionsCount + 1);
  };

  return (
    <div
      id={id}
      ref={dragRef}
      className={className}
      {...(dragProps?.draggableProps || {})}
    >
      <div className={classes.questionHeader}>
        <QuestionIcon
          className={classNames(classes.questionIcon, {
            [classes.questionIconMultiSelect]:
              question.type === QUESTIONNAIRE_QUESTION_TYPES.MULTI_SELECT,
          })}
        />
        <Typography variant="body2">{label}</Typography>
      </div>
      <QuestionnaireQuestionEntry
        translations={translations}
        item={question}
        isOpenEndedAttribute={isOpenEndedQuestion}
        hasDefinedAnswers={!isOpenEndedQuestion}
        dragProps={
          dragProps ? { dragHandleProps: dragProps.dragHandleProps } : null
        }
        errors={errors}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onSave={onSave}
        onPendingChange={onPendingChange}
        onRegisterFlush={onRegisterFlush}
      />
      {!isOpenEndedQuestion &&
        optionsCount < QUESTIONNAIRE_QUESTION_MAX_OPTIONS && (
          <div className={classes.addAnswerRow}>
            <CustomButton
              type="addWithTextDarkSlimNew"
              onClick={handleAddAnswer}
              fullWidth
            >
              {translations.addAnswer}
            </CustomButton>
          </div>
        )}
    </div>
  );
};

Question.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  dragRef: PropTypes.func,
  dragProps: PropTypes.object,
  errors: PropTypes.object,
  question: PropTypes.object.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onPendingChange: PropTypes.func,
  onRegisterFlush: PropTypes.func,
  onAddAnswer: PropTypes.func.isRequired,
};

export default Question;
